const initState = {
  noProfile: null
};

const searchProfileReducer = (state = initState, action) => {
  switch (action.type) {
    case "NO_PROFILE":
      return {
        ...state,
        noProfile: true
      };
    case "ERROR_SEARCH_PROFILE":
      return {
        ...state,
        noProfile: action.error
      };
    case "PROFILE_FOUND":
      return {
        ...state,
        noProfile: false
      };
    default:
      return state;
  }
};

export default searchProfileReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/searchReducer.tsx